import { render, staticRenderFns } from "./DutyManagementArchive.vue?vue&type=template&id=52582805"
import script from "./DutyManagementArchive.vue?vue&type=script&lang=js"
export * from "./DutyManagementArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports